
import { Component, Vue, Prop } from 'vue-property-decorator'
import { UserModule } from '../../store/modules/user'
import DashboardHeader from './DashboardHeader.vue'
  @Component({ 
    name: 'DashboardCourse',
    components: { DashboardHeader } 
  })
  
export default class DashboardCourse extends Vue {
    tableData: any = []
    type:number = 0
    title = ''
    tableHeight: number = window.innerHeight - 200
    list: any = []
    list1: any = []
    list2: any = []
    list3: any = []
    business_type = ''
    data_type = ''
    headerList: any = []
    instrumentTypes: any = []
    teacherType: any = []
    campusType: any = []
    time: any = [new Date(<any>new Date() - 1000 * 60 * 60 * 24 * 30),new Date()]
    start_time = ''
    end_time = ''
    loading = true

    getHeight() {
      window.onresize = () =>{
        this.tableHeight = window.innerHeight - 200
      }
    }

    async getInstrumentType(){ //乐器类型
      const res = await UserModule.InstrumentType()
      this.list3 = res.data.list
      this.dataType()
    }

    async getStudentLevel() {   // 获取学员等级
      const res = await UserModule.studentLevels()
      this.list2 = res.data.list
      this.getInstrumentType()
    }

    async gitCourseType() {  // 获取课程种类
      const res = await UserModule.courseType()
      this.list1 = res.data.list
      this.getStudentLevel()
    }

    async getTeaching() {
      const res = await UserModule.teaching({ data_type: this.data_type, instrument_type: this.instrumentTypes, campus_id: this.campusType, teacher_id: this.teacherType, start_time: this.start_time, end_time: this.end_time })
      let data =  res.data
      if(this.type == 1 || this.type == 2 || this.type == 3 || this.type == 4 || this.type == 5 || this.type == 6) {
        for(var i in data[0]) {
          if(i != 'total') {
            data[0][i] =  data[0][i] + ' ('+ ((data[0][i]/data[0]['total'])*100).toFixed(2)+'%' +')'
          }
        }
      }
      this.tableData = data
    }

    getDataChange(val:any){
      this.instrumentTypes = val.instrumentTypes
      this.teacherType = val.teacherType
      this.campusType = val.campusType
      this.time = val.time
      this.start_time = (Date.parse(this.time[0])/1000).toString()
      this.end_time = (Date.parse(this.time[1])/1000).toString()
      this.gitCourseType()
    }

    dataType() {
      this.type = Number(this.$route.query.type)
      if(this.type == 1) {  // 发布课程时长
        this.title = '发布课程时长'
        this.data_type = '1'
        const list = [{name: '时长',prop: 'total'}, {name: '正式课',prop: 'zhengshi'}, {name: '试听课',prop: 'shiting'}]
        for (var i = 0; i < this.list1.length; i++) {
          list.push({name: this.list1[i].name,prop: 'course_type_id'+this.list1[i].id})
        }
        this.list = list
        this.getTeaching()

      } else if (this.type == 2) {
        this.title = '教师工作时长'
        this.data_type = '2'
        const list = [{name: '时长',prop: 'total'}, {name: '正式课',prop: 'zhengshi'}, {name: '占用',prop: 'zhanyong'}, {name: '试听课',prop: 'shiting'}]
        for (var i = 0; i < this.list1.length; i++) {
          list.push({name: this.list1[i].name,prop: 'course_type_id'+this.list1[i].id})
        }
        this.list = list
        this.getTeaching()
      } else if (this.type == 3) {
        this.title = '学员等级分布'
        this.data_type = '3'
        const list = [{name: '人数',prop: 'total'}]
        for (var i = 0; i < this.list2.length; i++) {
          list.push({name: this.list2[i].name,prop: 'level_id'+this.list2[i].id})
        }
        this.list = list
        this.getTeaching()
      } else if (this.type == 4) {
        this.title = '消耗学员课时'
        this.data_type = '4'
        const list = [{name: '时长',prop: 'total'}, {name: '体系课',prop: 'tixi'}, {name: '非体系课',prop: 'feitixi'}, {name: '成人', prop: 'ages1'},{name: '儿童', prop: 'ages2'},{name: '学生', prop: 'ages3'}]
        for(var i = 0; i < this.list3.length; i++) {
          list.push({name: this.list3[i].name,prop: 'instrument_type_id'+this.list3[i].id})
        }
        for (var i = 0; i < this.list1.length; i++) {
          list.push({name: this.list1[i].name,prop: 'course_type_id'+this.list1[i].id})
        }
        for (var i = 0; i < this.list2.length; i++) {
          list.push({name: this.list2[i].name,prop: 'level_id'+this.list2[i].id})
        }
        this.list = list
        this.getTeaching()

      } else if (this.type == 5) {
        this.title = '学员上课人数'
        this.data_type = '5'
        const list = [{name: '人数',prop: 'total'}]
        const list4 = [{name: '成人', prop: 'ages1'},{name: '儿童', prop: 'ages2'},{name: '学生', prop: 'ages3'}]
        for(var i = 0; i < this.list3.length; i++) {
          list.push({name: this.list3[i].name,prop: 'instrument_type_id'+this.list3[i].id})
        }
        for(var j = 0; j < list4.length;j++) {
          list.push(list4[j])
        }
        for (var i = 0; i < this.list1.length; i++) {
          list.push({name: this.list1[i].name,prop: 'course_type_id'+this.list1[i].id})
        }
        for (var i = 0; i < this.list2.length; i++) {
          list.push({name: this.list2[i].name,prop: 'level_id'+this.list2[i].id})
        }
        this.list = list
        this.getTeaching()
      } else if (this.type == 6 || this.type == 7) {
        if(this.type == 6) {
          this.title = '完成各等级人数'
          this.data_type = '6'
          this.list = [{name: '人数', prop: 'total'}]
        } else if (this.type == 7) {
          this.title = '完成各等级课时'
          this.data_type = '7'
          this.list = [{name: '课时', prop: 'total'}]
        }
        
        for(var i = 0; i < this.list2.length;i++){
          if(i === 0) {
            this.list.push({name: this.list2[i].name, prop: 'level_id'+this.list2[i].id })
          } else {
            this.list.push({name: this.list2[i-1].name + '-升-' + this.list2[i].name, prop: 'level_id'+this.list2[i].id})
          }
        }
        this.getTeaching()
      }
    }

    setCookie(cname, cvalue, exdays) {
      var d = new Date()
      d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000))
      var expires = 'expires=' + d.toUTCString()
      document.cookie = cname + '=' + cvalue + '; ' + expires
    }

    toStudentDeatil(val) {
      let type = ''
      let key: string = ''
      let value: string = ''
      if(val.prop.includes('level_id')) {
        key = 'level_id'
        value = val.prop.replace('level_id','')
      } else if (val.prop.includes('course_type_id')) {
        key = 'course_type_id'
        value = val.prop.replace('course_type_id','')
      } else if (val.prop.includes('ages')) {
        key = 'ages'
        value = val.prop.replace('ages','')
      } else if (val.prop.includes('instrument_type_id')) {
        const keys: any = 'instrument_type_id'
        const values: any = [val.prop.replace('instrument_type_id','')]
        this.setCookie('instrumentTypes', JSON.stringify(values), 1)
      } else if (val.prop === 'zhengshi'){
        key = 'course_type',
        value = '1'
      } else if (val.prop === 'shiting'){
        key = 'shiting',
        value = '2'
      } else if (val.prop === 'zhanyong') {
        key = 'zhanyong',
        value = '3'
      } else if (val.prop === 'tixi'){
        key = 'is_formal',
        value = '1'
      } else if (val.prop === 'feitixi'){
        key = 'is_formal',
        value = '2'
      } else if (val.prop.includes('level_id')){
        const keys: any = 'level_id'
        const values: any = [val.prop.replace('level_id','')]
      } else {
        key = ''
        value = ''
      }

      if(this.type === 5 || this.type === 3 || this.type === 6) {
        type = '/customer/student'
      } else if (this.type === 2 || this.type === 4) {
        type = '/course/sign'
      } else if (this.type === 1) {
        if(value === '2') {
          type = '/course/audition'
        } else {
          type = '/course/sign'
        }
      }

      if(type) {
        this.$router.push({ path: `${type}`, query: { from: 'student', key: key, value: value, campus: JSON.stringify(this.campusType),time: JSON.stringify(this.time),teacher: JSON.stringify(this.teacherType), instrument: JSON.stringify(this.instrumentTypes) } })
      }
    }

    mounted(){
      this.getHeight()
    }
  }
